import { gql } from '@apollo/client';

import { AuthTokensFragment } from '../fragments';

export const RegisterStudentMutation = gql`
    mutation RegisterStudent($args: RegisterStudentArgs!) {
        registerStudent(args: $args) {
            ...AuthTokens
        }
    }
    ${AuthTokensFragment}
`;
